import React from "react";

function WhyChSolana() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Why Choose Solana for Your Blockchain Project?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  Solana has emerged as one of the most efficient and scalable
                  blockchain platforms, ideal for DeFi applications, NFT
                  marketplaces, and gaming projects. Solana’s unique Proof of
                  History (PoH) mechanism enables it to handle thousands of
                  transactions per second at minimal costs, making it an optimal
                  choice for businesses looking to scale.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default WhyChSolana;
